<div class="selected-container">
  <nz-tag *ngFor="let tag of _values?.covers" nzMode="closeable" (nzAfterClose)="handleClose(tag,'cover')">{{tag.name}}</nz-tag>
  <nz-tag *ngFor="let tag of _values?.industries" nzMode="closeable" (nzAfterClose)="handleClose(tag,'industry')">{{tag.name}}</nz-tag>
  <nz-tag *ngFor="let tag of _values?.states" nzMode="closeable" (nzAfterClose)="handleClose(tag,'state')">{{tag.shortName}}</nz-tag>
</div>
